import type { DictationCheckErrorKind } from 'hooks/useDictationCheck';

export const STILL_CHECKING_DELAY_MS = 3000;

export const DICTATION_CHECK_ERROR_MESSAGES: Record<DictationCheckErrorKind, string> = {
  unauthenticated: 'Your session has expired. Sign in again, then retry.',
  disabled: 'Dictation check is not available right now.',
  invalid: 'This report could not be checked.',
  model_failed: 'The check could not be completed. Please try again.',
  timeout: 'The check took too long. Please try again.',
  network: 'The check could not be reached. Please try again.',
};

export const DICTATION_CHECK_ISSUE_LABEL = { singular: 'issue', plural: 'issues' } as const;

export const DICTATION_CHECK_FALLBACK_SECTION_HEADING = 'Other';

// Placeholder until Product supplies the final text (PRD NFR-07).
export const DICTATION_CHECK_AI_DISCLAIMER =
  'AI-generated suggestions. Review before relying on them.';

export const DICTATION_CHECK_REMOVED_LABEL = '(removed)';
export const DICTATION_CHECK_NO_ORIGINAL_LABEL = '(none)';

// Keyed by the API's `subtype`, which the generated type exposes as a plain string.
export const DICTATION_CHANGE_SUBTYPE_LABELS: Record<string, string> = {
  punctuation: 'Punctuation',
  term: 'Term',
  dropped_word: 'Dropped word',
  filler: 'Filler',
  capitalization: 'Capitalization',
  banned_word: 'Banned word',
  date_format: 'Date format',
};

export const DICTATION_CHECK_PARAGRAPH_VIEW_LABELS = {
  heading: 'Changed paragraphs',
  toggle: 'Paragraph view',
  original: 'Original',
  corrected: 'Corrected',
} as const;

// Read by screen readers only, so struck, highlighted, and zero-width changes don't rely on styling.
export const DICTATION_CHECK_HIDDEN_LABELS = {
  struck: 'Removed: ',
  added: 'Added: ',
  insertionPoint: 'Text is added here. ',
  removalPoint: 'Text is removed here. ',
} as const;

export const AUTO_APPLY_AUTOCORRECT = false;

export const INLINE_CORRECTIONS = true;
